import React, { useRef } from 'react';
import { useRestaurant } from '../context/RestaurantContext';
import { useLanguage } from '../context/LanguageContext';
interface CategoryNavProps {
  activeCategory: string;
  onSelectCategory: (category: string) => void;
}
export function CategoryNav({
  activeCategory,
  onSelectCategory
}: CategoryNavProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const {
    t,
    translateCategory
  } = useLanguage();
  const {
    categories
  } = useRestaurant();
  const handleSelect = (category: string) => {
    onSelectCategory(category);
    const el = scrollRef.current?.querySelector(`[data-cat="${category}"]`) as HTMLElement;
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  };
  return <div className="sticky top-0 z-20 bg-carbon/95 backdrop-blur-sm py-2 px-4 -mx-4 mb-4" data-id="element-763">
      <div ref={scrollRef} className="flex overflow-x-auto hide-scrollbar gap-2 pb-1" style={{
      touchAction: 'pan-x',
      WebkitOverflowScrolling: 'touch'
    }} data-id="element-764">
        <button data-cat="Todos" onClick={() => handleSelect('Todos')} className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-colors min-h-[44px] flex-shrink-0 ${activeCategory === 'Todos' ? 'bg-verde text-carbon shadow-md' : 'bg-surface text-gray-400 border border-gray-800'}`} data-id="element-765">
          {t('all')}
        </button>
        {categories.map(category => <button key={category} data-cat={category} onClick={() => handleSelect(category)} className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-colors min-h-[44px] flex-shrink-0 ${activeCategory === category ? 'bg-verde text-carbon shadow-md' : 'bg-surface text-gray-400 border border-gray-800'}`} data-id="element-766">
            {translateCategory(category)}
          </button>)}
      </div>
    </div>;
}